import { defaultProgramDetails } from "./programDetails";

export const DEFAULT_REGION_KEY = "IN";
export const USA_HOME_BANNER_IMAGE = "/assets/agm/home-usa-times-square-yoga.jpg";
const PUBLIC_LIFE_BASE = "/assets/agm/public-life";
const PUBLIC_TRUST_HOME_BANNER = `${PUBLIC_LIFE_BASE}/pm-modi-swamiji-home-banner.png`;
const LEGACY_US_BANNER_IMAGE = "/assets/agm/web/usa-presence/times-square-yoga-2022.jpg";

export const missionSiteFallback = {
  visitAnnouncement: { enabled: false, headline: '', subtext: '', dateRange: '', citiesLine: '', backgroundImage: '', ctaLabel: 'Schedule a Visit' },
  brand: {
    name: "AvdheshanandG Mission",
    shortName: "AGM",
    promise: "Wisdom in practice. Service with dignity. Giving with accountability.",
  },
  regions: {
    IN: {
      key: "IN",
      label: "India",
      countryCodes: ["IN"],
      currency: "INR",
      amountPrefix: "₹",
      paymentProvider: "razorpay",
      paymentLabel: "Donate in INR",
      donationPath: "/donate-form?region=IN",
      bannerImage: "/assets/agm/hero-india.jpg",
      bannerImageMobile: "",
      eyebrow: "India mission",
      title: "Seva in action across healthcare, education, dignity and Vedantic wisdom.",
      subtitle:
        "From the Swami Avdheshanand Polyclinic and Champawat school to Mahakumbh relief and future-skilling classrooms, AGM turns spiritual conviction into measurable social upliftment.",
      primaryCta: "Support seva in India",
      secondaryCta: "Explore impact",
      contactLine: "India programs: healthcare, school education, skilling and relief seva.",
      heroSlides: [
        {
          image: PUBLIC_TRUST_HOME_BANNER,
          imageMobile: "",
          imageAlt:
            "Pujya Swami Avdheshanand Giri ji presenting The Path to Ananda to Prime Minister Narendra Modi",
          imagePosition: "right center",
          imageLayout: "wideBanner",
          hideHeroPanel: true,
          eyebrow: "Public trust",
          title: "Respected in public life. Rooted in seva.",
          subtitle:
            "Pujya Swami Avdheshanand Giri Ji Maharaj's national spiritual presence gives AGM a trusted foundation for healthcare, education, dignity, relief and Vedantic wisdom in action.",
          titleMobile: "",
          subtitleMobile: "",
          primaryCta: "Support seva in India",
          primaryHref: "/donate-form?region=IN",
          secondaryCta: "Explore impact",
          secondaryHref: "/impact",
        },
        {
          image: "/assets/agm/polyclinic/polyclinic-medical-team.jpg",
          imageMobile: "",
          imageAlt: "Swami Avdheshanand Polyclinic medical team and medicines",
          imagePosition: "center",
          eyebrow: "Healthcare seva",
          title: "Healthcare access with dignity at the point of care.",
          subtitle:
            "Swami Avdheshanand Polyclinic supports consultations, medicines and preventive care so families receive dependable health support close to home.",
          titleMobile: "",
          subtitleMobile: "",
          primaryCta: "Support healthcare",
          primaryHref: "/programs/healthcare",
          secondaryCta: "View programs",
          secondaryHref: "/programs",
        },
        {
          image: "/assets/agm/school/school-students-staff.jpg",
          imageMobile: "",
          imageAlt: "Swami Avdheshanand Public School students and staff",
          imagePosition: "center",
          eyebrow: "Education",
          title: "Values-led education that builds confidence and character.",
          subtitle:
            "AGM strengthens learning through school education, cultural grounding, stage confidence and future-ready aspirations for children.",
          titleMobile: "",
          subtitleMobile: "",
          primaryCta: "Explore school",
          primaryHref: "/programs/school",
          secondaryCta: "Support education",
          secondaryHref: "/donate-form?campaign=champawat",
        },
        {
          image: "/assets/agm/mass-wedding-dignitaries.jpg",
          imageMobile: "",
          imageAlt: "Shagun Vivah Utsav 2026 with couples, families and dignitaries",
          imagePosition: "center",
          eyebrow: "Dignity",
          title: "Public service that protects dignity and creates new beginnings.",
          subtitle:
            "From Shagun Vivah Utsav to Mahakumbh seva, AGM organizes support that families, pilgrims and communities can feel in daily life.",
          titleMobile: "",
          subtitleMobile: "",
          primaryCta: "See impact",
          primaryHref: "/impact",
          secondaryCta: "Support dignity",
          secondaryHref: "/programs/mass-wedding",
        },
      ],
      donationTiers: [
        { amount: 2100, impactLine: "", highlighted: false },
        { amount: 5100, impactLine: "", highlighted: true },
        { amount: 11000, impactLine: "", highlighted: false },
        { amount: 51000, impactLine: "", highlighted: false },
      ],
      blessing: "",
    },
    US: {
      key: "US",
      label: "United States",
      countryCodes: ["US", "CA", "GB", "AU", "AE", "SG", "NZ", "EU"],
      currency: "USD",
      amountPrefix: "$",
      paymentProvider: "stripe",
      paymentLabel: "Donate in USD",
      donationPath: "/donate-form?region=US",
      bannerImage: USA_HOME_BANNER_IMAGE,
      bannerImageMobile: "",
      bannerPosition: "center 72%",
      eyebrow: "AGM USA",
      title: "Guided by wisdom. Rooted in service.",
      subtitle:
        "AvdheshanandG Mission brings the teachings of Pujya Swami Avdheshanand Giri Ji Maharaj into practical seva: education, healthcare, dignity, relief and community upliftment supported with clarity for U.S. donors.",
      primaryCta: "Donate Now",
      secondaryCta: "Learn About Our Work",
      contactLine:
        "Give in the spirit of seva. Your support helps values-based charitable programs grow with dignity, transparency and care.",
      heroSlides: [
        {
          image: PUBLIC_TRUST_HOME_BANNER,
          imageMobile: "",
          imageAlt:
            "Pujya Swami Avdheshanand Giri ji presenting The Path to Ananda to Prime Minister Narendra Modi",
          imagePosition: "right center",
          imageLayout: "wideBanner",
          hideHeroPanel: true,
          eyebrow: "Public trust",
          title: "A trusted spiritual presence. A mission built for seva.",
          subtitle:
            "For U.S. audiences discovering Swami ji, AGM connects his respected public stature and Vedantic guidance to practical service: healthcare, education, dignity, relief and transparent giving.",
          titleMobile: "",
          subtitleMobile: "",
          primaryCta: "Donate Now",
          primaryHref: "/donate-form?region=US",
          secondaryCta: "Explore public presence",
          secondaryHref: "/global-presence",
        },
        {
          image: "/assets/agm/global-presence/times-square-yoga-stage.jpg",
          imageMobile: "",
          imageAlt: "Pujya Swami Avdheshanand Giri ji speaking at Solstice in Times Square",
          imagePosition: "center",
          eyebrow: "U.S. presence",
          title: "Yoga, Vedant and seva in the public square.",
          subtitle:
            "For U.S. audiences, Swami ji's presence opens a direct path from spiritual inspiration to organized social impact through AGM.",
          titleMobile: "",
          subtitleMobile: "",
          primaryCta: "Explore presence",
          primaryHref: "/global-presence",
          secondaryCta: "Donate in USD",
          secondaryHref: "/donate-form?region=US",
        },
        {
          image: "/assets/agm/polyclinic/polyclinic-medanta-mobile-unit.jpg",
          imageMobile: "",
          imageAlt: "Swami Avdheshanand Polyclinic team with Medanta mobile healthcare unit",
          imagePosition: "center",
          eyebrow: "Healthcare seva",
          title: "Care that reaches people with respect.",
          subtitle:
            "Your support can strengthen medical access, medicines, preventive care and healthcare partnerships for families who need dignified support.",
          titleMobile: "",
          subtitleMobile: "",
          primaryCta: "Support healthcare",
          primaryHref: "/programs/healthcare",
          secondaryCta: "See impact",
          secondaryHref: "/impact",
        },
        {
          image: "/assets/agm/school/school-cultural-stage.jpg",
          imageMobile: "",
          imageAlt: "Students of Swami Avdheshanand Public School performing on stage",
          imagePosition: "center",
          eyebrow: "Education and culture",
          title: "Confidence, culture and future-ready learning.",
          subtitle:
            "AGM supports school education and future skilling so young people grow with character, digital exposure and a stronger path toward opportunity.",
          titleMobile: "",
          subtitleMobile: "",
          primaryCta: "Explore education",
          primaryHref: "/programs/school",
          secondaryCta: "Fund a learner",
          secondaryHref: "/programs/future-skilling",
        },
      ],
      donationTiers: [
        { amount: 51, impactLine: "", highlighted: false },
        { amount: 108, impactLine: "", highlighted: true },
        { amount: 501, impactLine: "", highlighted: false },
        { amount: 1008, impactLine: "", highlighted: false },
      ],
      blessing: "",
    },
  },
  impactStats: [
    {
      value: "60,000+",
      label: "Meals served",
      detail: "Prepared and distributed during Mahakumbh seva.",
    },
    {
      value: "31,669",
      label: "Pilgrims treated",
      detail: "Medical care delivered at Mahakumbh camps.",
    },
    {
      value: "2,000",
      label: "Youth per year",
      detail: "Targeted through Institute of Future Skilling.",
    },
    {
      value: "51",
      label: "Couples supported",
      detail: "Shagun Vivah Utsav 2026 supported with dignity, essentials and public blessings.",
    },
  ],
  programPillars: [
    {
      id: "healthcare",
      icon: "HeartPulse",
      eyebrow: "Healthcare",
      title: "Swami Avdheshanand Polyclinic",
      description:
        "Accessible consultation, medicines and preventive care for families who need dependable health support close to home.",
      image: "/assets/agm/polyclinic.jpg",
      metrics: [
        "100+ patients served regularly",
        "General, dental and eye-care support",
        "Medicine and consultation access",
      ],
      ctaLabel: "Support healthcare",
      ctaHref: "/donate-form?campaign=healthcare",
    },
    {
      id: "future-skilling",
      icon: "MonitorCog",
      eyebrow: "Future skilling",
      title: "Institute of Future Skilling",
      description:
        "Free practical training in coding, design, video editing, accounting tools, cyber awareness and career readiness for young people preparing for better livelihoods.",
      image: "/assets/agm/ifs-lab.jpg",
      metrics: [
        "2,000 learners annual ambition",
        "Girls and transgender learners included",
        "Job-linked digital skills",
      ],
      ctaLabel: "Fund a learner",
      ctaHref: "/donate-form?campaign=ifs",
    },
    {
      id: "school",
      icon: "GraduationCap",
      eyebrow: "School education",
      title: "Swami Avdheshanand Public School, Champawat",
      description:
        "A values-led school environment where children gain academic confidence, cultural grounding, discipline, stage exposure and aspiration.",
      image: "/assets/agm/school/school-students-staff.jpg",
      metrics: [
        "Values-led education",
        "Cultural and stage confidence",
        "Rural education upliftment",
      ],
      ctaLabel: "Strengthen classrooms",
      ctaHref: "/donate-form?campaign=champawat",
    },
    {
      id: "mahakumbh",
      icon: "ShieldPlus",
      eyebrow: "Relief and pilgrimage seva",
      title: "Mahakumbh Seva",
      description:
        "Food, shelter, medical care, transport and safety support for pilgrims during one of the world’s largest spiritual gatherings.",
      image: "/assets/agm/mahakumbh-medical.jpg",
      metrics: ["35,000+ sheltered", "100+ medical camps", "4,000 warm blankets distributed"],
      ctaLabel: "Back relief seva",
      ctaHref: "/donate-form?campaign=mahakumbh",
    },
    {
      id: "mass-wedding",
      icon: "HandHeart",
      eyebrow: "Women’s dignity",
      title: "Shagun Vivah Utsav 2026",
      description:
        "A dignity-centered mass wedding initiative where 51 couples began married life with blessings, financial support, household essentials and community honor.",
      image: "/assets/agm/mass-wedding-ceremony.jpg",
      metrics: [
        "51 couples supported",
        "₹1 lakh support cheques and household essentials",
        "With Ladli Foundation, Rashi Entertainment and civic dignitaries",
      ],
      ctaLabel: "Support dignity",
      ctaHref: "/donate-form?campaign=mass-wedding",
    },
    {
      id: "vedant",
      icon: "BookOpenCheck",
      eyebrow: "Vedantic wisdom",
      title: "Vedant for Public Life",
      description:
        "Swami ji’s Vedantic guidance gives the mission its inner compass: service without ego, dignity without discrimination and action rooted in oneness.",
      image: "/assets/agm/swamiji-vedant.jpg",
      metrics: [
        "Wisdom-led service",
        "Character and compassion",
        "Spiritual education for society",
      ],
      ctaLabel: "Learn the vision",
      ctaHref: "/vedant",
    },
  ],
  programDetails: defaultProgramDetails,
  stories: [
    {
      eyebrow: "Featured seva",
      title: "Mahakumbh: care at human scale",
      text: "AGM’s Mahakumbh seva brought food, clinical care, shelter, blankets, transport and emergency support to pilgrims moving through an intense spiritual gathering.",
      image: "/assets/agm/mahakumbh-satsang.jpg",
    },
    {
      eyebrow: "Future readiness",
      title: "Digital skills that open livelihood paths",
      text: "The Institute of Future Skilling gives students practical access to modern tools, employability training and the confidence to participate in a changing economy.",
      image: "/assets/agm/ifs-students.jpg",
    },
    {
      eyebrow: "Women’s dignity",
      title: "Shagun Vivah Utsav 2026: 51 beginnings with dignity",
      text: "At The Zora Convention Centre in New Delhi, AGM joined partners to support 51 couples through a grand ceremony with household essentials, public blessings and a message of dignity.",
      image: "/assets/agm/mass-wedding-dignitaries.jpg",
    },
  ],
  usaPresence: {
    title: "A living connection with the U.S. diaspora",
    description:
      "Swami ji’s public visits and recognitions in America give U.S. supporters a direct bridge to his teachings and to service inspired by Vedant.",
    events: [
      {
        year: "2022",
        place: "Times Square, New York",
        title: "International Yoga Day leadership",
        imageUrl: "/assets/agm/web/usa-presence/times-square-yoga-2022.jpg",
        imageMobile: "",
        imageAlt: "Swami Avdheshanand Giri ji at International Yoga Day in Times Square",
        text: "Swami ji was invited as Guest of Honour for Solstice Yoga at Times Square during the 8th International Day of Yoga, connecting yoga, wellness and community life.",
        sourceLabel: "Economic Times",
        sourceUrl:
          "https://economictimes.indiatimes.com/news/india/indian-spiritual-leader-to-lead-international-yoga-day-celebrations-in-the-us/articleshow/92070217.cms",
      },
      {
        year: "2022",
        place: "New York, New Jersey and Long Island",
        title: "Community interactions during North America visit",
        imageUrl: "/assets/agm/web/usa-presence/north-america-arrival-2022.jpg",
        imageMobile: "",
        imageAlt: "Swami Avdheshanand Giri ji welcomed during his North America visit",
        text: "During the same North America visit, public coverage noted planned community interactions in New Jersey and Long Island.",
        sourceLabel: "Economic Times",
        sourceUrl:
          "https://economictimes.indiatimes.com/news/india/indian-spiritual-leader-to-lead-international-yoga-day-celebrations-in-the-us/articleshow/92070217.cms",
      },
      {
        year: "2024",
        place: "Madison Avenue, New York",
        title: "India Day Parade spiritual presence",
        imageUrl: "/assets/agm/web/usa-presence/india-day-parade-2024.jpg",
        imageMobile: "",
        imageAlt: "Swami Avdheshanand Giri ji blessing the crowd at the New York India Day Parade",
        text: "At the 42nd India Day Parade, Swami ji joined the Indian-American community around the message of Vasudhaiva Kutumbakam: the world as one family.",
        sourceLabel: "FIA NY-NJ-CT",
        sourceUrl:
          "https://fianynjct.org/news-media/42nd-India-Day-Parade-Embodies-One-World-One-Family-in-Peaceful-Multi-Cultural/",
      },
      {
        year: "2008",
        place: "Sunnyvale Hindu Temple, California",
        title: "Hindu Renaissance Award",
        imageUrl: "/assets/agm/web/usa-presence/hindu-renaissance-award-2008.jpg",
        imageMobile: "",
        imageAlt:
          "Swami Avdheshanand Giri ji featured by Hinduism Today for the Hindu Renaissance Award",
        text: "Hinduism Today presented Swami ji the 2008 Hindu Renaissance Award during a satsang at Sunnyvale Hindu Temple in California.",
        sourceLabel: "Hinduism Today",
        sourceUrl:
          "https://www.hinduismtoday.com/magazine/january-february-march-2009/2009-01-swami-avdheshananda-giri-hindu-of-the-year/",
      },
    ],
  },
  homePresence: {
    global: {
      eyebrow: "Global presence and lineage",
      title: "Swami ji’s stature opens the door. AGM turns that trust into seva.",
      description:
        "For visitors in the U.S. and beyond, Swami ji’s public presence, guru-parampara and global spiritual dialogue create context. The next step is practical participation in healthcare, education, dignity and relief.",
      primaryCtaLabel: "Explore presence",
      primaryCtaHref: "/global-presence",
      secondaryCtaLabel: "Vedant foundation",
      secondaryCtaHref: "/vedant",
      highlights: [
        {
          eyebrow: "U.S. public presence",
          place: "Times Square, New York",
          title: "Yoga and Vedantic wellness in the public square.",
          text: "Swami ji's presence at Times Square gives U.S. audiences an immediate entry point: yoga, inner discipline and service are not separate paths, but one public ethic.",
          image: "/assets/agm/global-presence/times-square-yoga-day.jpg",
          imageMobile: "",
          alt: "Pujya Swami Avdheshanand Giri ji with community members at International Yoga Day in Times Square",
          objectPosition: "center",
        },
        {
          eyebrow: "Global harmony",
          place: "Interfaith dialogue",
          title: "Dialogue across traditions, rooted in respect.",
          text: "AGM can present Swami ji's global spiritual presence as a bridge: Vedant deepens identity while widening compassion toward every community.",
          image: "/assets/agm/global-presence/interfaith-sankalp.jpg",
          imageMobile: "",
          alt: "Pujya Swami Avdheshanand Giri ji with leaders from multiple faith traditions",
          objectPosition: "center 35%",
        },
        {
          eyebrow: "Public life",
          place: "National leadership",
          title: "A spiritual voice trusted in civic spaces.",
          text: "Swami ji's engagement with public leaders reflects a wider trust in his guidance, while AGM keeps its focus on measurable seva outcomes.",
          image: "/assets/agm/global-presence/president-of-india-meeting.jpg",
          imageMobile: "",
          alt: "Pujya Swami Avdheshanand Giri ji meeting national public leadership",
          objectPosition: "center top",
        },
        {
          eyebrow: "Seva infrastructure",
          place: "Healthcare guidance",
          title: "Spiritual inspiration supporting modern service institutions.",
          text: "The same guidance that speaks of oneness also supports practical care: clinics, equipment, partnerships and health access for people in need.",
          image: "/assets/agm/global-presence/hospital-equipment-guidance.jpg",
          imageMobile: "",
          alt: "Pujya Swami Avdheshanand Giri ji viewing healthcare equipment with medical professionals",
          objectPosition: "center",
        },
      ],
      lineage: [
        {
          eyebrow: "Guru-parampara",
          title: "Lineage gives service its inner discipline.",
          text: "AGM's seva is anchored in guru-parampara, sannyas dharma and Vedantic responsibility: service offered with humility, discipline and reverence.",
          image: "/assets/agm/global-presence/guru-parampara-bharat-mata-mandir.jpg",
          imageMobile: "",
          alt: "Pujya Swami Avdheshanand Giri ji with his Guru in a guru-parampara setting",
          objectPosition: "center",
        },
        {
          eyebrow: "Monastic fraternity",
          title: "Sadhus and acharyas hold a living tradition.",
          text: "Sannyas and sadhu gatherings reveal the spiritual discipline behind public seva: a life trained toward restraint, responsibility and service.",
          image: "/assets/agm/global-presence/sannyas-home-haridwar.jpg",
          imageMobile: "",
          alt: "Sadhus gathered with Pujya Swami Avdheshanand Giri ji in Haridwar",
          objectPosition: "center",
        },
        {
          eyebrow: "Sacred institutions",
          title: "Bharat Mata Mandir and sacred memory.",
          text: "Bharat Mata Mandir connects Vedantic wisdom, national cultural memory and social duty, reminding visitors that devotion must also protect society.",
          image: "/assets/agm/global-presence/bharat-mata-mandir-lineage.jpg",
          imageMobile: "",
          alt: "Pujya Swami Avdheshanand Giri ji with saints at Bharat Mata Mandir",
          objectPosition: "center",
        },
        {
          eyebrow: "Pilgrimage dharma",
          title: "Sacred geography becomes social responsibility.",
          text: "Pilgrimage imagery can lead visitors toward AGM's relief work, health camps, food seva and dignity-centered care for pilgrims.",
          image: "/assets/agm/global-presence/amarnath-darshan.jpg",
          imageMobile: "",
          alt: "Pujya Swami Avdheshanand Giri ji at Amarnath with devotees and attendants",
          objectPosition: "center",
        },
      ],
    },
    publicTrust: {
      eyebrow: "Public trust",
      title: "Recognized in public life, directed toward service.",
      description:
        "These moments help new visitors understand Swami ji’s stature. The experience must then turn that respect into AGM’s real work: healthcare, education, dignity, relief and transparent giving.",
      galleryCtaHref: "/global-presence",
      moments: [
        {
          category: "National leadership",
          eyebrow: "Public trust",
          title: "A trusted spiritual presence in national life.",
          text: "Dialogues with national leadership help new visitors understand Swami ji's public stature. AGM uses that trust to invite disciplined participation in healthcare, education, dignity and relief seva.",
          image: "/assets/agm/public-life/pm-modi-swamiji-dialogue.jpg",
          imageMobile: "",
          featureImage: "/assets/agm/public-life/pm-modi-swamiji-seated-dialogue.jpg",
          featureImageMobile: "",
          alt: "Pujya Swami Avdheshanand Giri ji in dialogue with Prime Minister Narendra Modi",
          featureAlt:
            "Pujya Swami Avdheshanand Giri ji seated in dialogue with Prime Minister Narendra Modi",
          featureAspect: "16 / 9",
          featureImageFit: "contain",
          featureObjectPosition: "center",
          objectPosition: "center",
        },
        {
          category: "Rashtrapati Bhavan",
          eyebrow: "Civic recognition",
          title: "A spiritual voice received with respect across public institutions.",
          text: "Such moments establish credibility for audiences who may be discovering Swami ji for the first time, while AGM keeps the next step clear: support measurable seva.",
          image: "/assets/agm/public-life/president-of-india-meeting-v2.jpg",
          imageMobile: "",
          featureImage: "",
          featureImageMobile: "",
          alt: "Pujya Swami Avdheshanand Giri ji meeting the President of India",
          featureAlt: "",
          featureAspect: "",
          featureImageFit: "",
          featureObjectPosition: "",
          objectPosition: "center top",
        },
        {
          category: "State leadership",
          eyebrow: "Public service dialogue",
          title: "Spiritual leadership in conversation with state and civic leaders.",
          text: "These images act as trust bridges: respected public relationships that strengthen the mission's ability to mobilize people for social upliftment.",
          image: "/assets/agm/public-life/yogi-adityanath-meeting-v2.jpg",
          imageMobile: "",
          featureImage: "",
          featureImageMobile: "",
          alt: "Pujya Swami Avdheshanand Giri ji with Uttar Pradesh public leadership",
          featureAlt: "",
          featureAspect: "",
          featureImageFit: "",
          featureObjectPosition: "",
          objectPosition: "center top",
        },
        {
          category: "National forums",
          eyebrow: "Cultural leadership",
          title: "Dharma, culture and public responsibility meeting on one platform.",
          text: "Public forums allow Swami ji's Vedantic guidance to reach civic, cultural and administrative audiences, turning respect into a broader call for service.",
          image: "/assets/agm/public-life/public-dialogue-sangh.jpg",
          imageMobile: "",
          featureImage: "",
          featureImageMobile: "",
          alt: "Pujya Swami Avdheshanand Giri ji in conversation with public and cultural leadership",
          featureAlt: "",
          featureAspect: "",
          featureImageFit: "",
          featureObjectPosition: "",
          objectPosition: "center",
        },
        {
          category: "Seva context",
          eyebrow: "Dharmic stewardship",
          title: "Seva includes care for living traditions and all beings.",
          text: "Gaushala and dharmic stewardship imagery helps connect Vedantic compassion with daily responsibility, humility and care.",
          image: "/assets/agm/public-life/gaushala-seva.jpg",
          imageMobile: "",
          featureImage: "",
          featureImageMobile: "",
          alt: "Pujya Swami Avdheshanand Giri ji feeding cows in a gaushala",
          featureAlt: "",
          featureAspect: "",
          featureImageFit: "",
          featureObjectPosition: "",
          objectPosition: "center",
        },
      ],
    },
  },
  swamiji: {
    eyebrow: "The guiding inspiration",
    title: "Pujya Swami Avdheshanand Giri Ji Maharaj",
    image: "/assets/agm/swamiji-guiding-inspiration.jpg",
    description:
      "Pujya Swami Avdheshanand Giri Ji Maharaj is a respected Hindu spiritual leader, Vedantic teacher, author and Acharya Mahamandaleshwar of Shri Panchdashnam Juna Akhara. AGM carries his message into service: spiritual growth and responsibility toward society belong together.",
    bullets: [
      "Acharya Mahamandaleshwar of Shri Panchdashnam Juna Akhara.",
      "Known for Vedantic teaching, public discourses, interfaith respect and social-service inspiration.",
      "His message is simple and universal: inner discipline must deepen compassion and service.",
    ],
    audiencePaths: [
      {
        title: "Devotees and well-wishers",
        eyebrow: "Devotees and well-wishers",
        text: "Offer your reverence through structured seva. Support a campaign, volunteer your expertise or help build a U.S. circle around education, wellness and dignity.",
        ctaLabel: "Support AGM Seva",
        ctaHref: "/donate-form?region=US",
      },
      {
        title: "New to Swami ji",
        eyebrow: "First-time supporters",
        text: "Begin with his role, teachings and public life, then see how AGM translates Vedantic oneness into service that is practical, respectful and accountable.",
        ctaLabel: "Know More About Swami ji",
        ctaHref: "https://www.avdheshanandg.org/",
      },
    ],
    ctaLabel: "Know More About Swami ji",
    ctaHref: "https://www.avdheshanandg.org/",
    secondaryCtaLabel: "See Vedant in Seva",
    secondaryCtaHref: "/vedant",
  },
  homepageAdditions: [
    {
      title: "Give with clarity",
      text: "Choose a campaign, understand what it supports and give through a U.S.-oriented donation path.",
    },
    {
      title: "Serve with skill",
      text: "Mentor students, support medical care, help with reporting or organize a local seva circle.",
    },
    {
      title: "Follow the work",
      text: "Read reports, program updates and field stories that show how support becomes service.",
    },
    {
      title: "Build community",
      text: "Invite families, professionals and partner organizations to participate in values-based charitable work.",
    },
  ],
  vedant: {
    image: "/assets/agm/web/usa-presence/hindu-renaissance-award-2008.jpg",
    title: "Vedant gives seva its inner discipline.",
    quote:
      "Vedant teaches the unity of life. Seva turns that insight into education, wellness, dignity and relief for people facing hardship.",
    principles: [
      "Seva as disciplined responsibility, not charity from a distance.",
      "Dignity for every beneficiary, family, student, patient and pilgrim.",
      "Education that builds skill, character and self-trust.",
      "Transparent action so devotion becomes accountable public good.",
    ],
  },
  transparency: {
    title: "Responsible stewardship",
    description:
      "Trust is earned through clear programs, careful reporting and honest communication. AGM will continue to share reports, field photographs and program updates so supporters can see what their giving makes possible.",
    reports: [
      {
        label: "Annual Report 2024-25",
        href: "/assets/agm/reports/agm-annual-report-2024-2025.pdf",
        note: "Together for Change",
      },
      {
        label: "Annual Report 2023-24",
        href: "/assets/agm/reports/agm-annual-report-2023-2024.pdf",
        note: "Education, women’s dignity and health",
      },
      {
        label: "Annual Report 2022-23",
        href: "/assets/agm/reports/agm-annual-report-2022-2023.pdf",
        note: "Skill development and social welfare",
      },
    ],
  },
  disclosures: {
    sections: [
      {
        heading: "Our commitment to transparency",
        body: "Every contribution to AvdheshanandG Mission is received as seva and committed to the mission's charitable work. We share programs, field updates and reports so supporters can see what their giving makes possible.",
      },
    ],
    fundUse: [
      {
        label: "Programs & seva",
        note: "The majority of every contribution supports AGM's charitable programs.",
      },
      {
        label: "Operations",
        note: "A modest share sustains the people and systems that deliver the work responsibly.",
      },
    ],
    contact: {
      email: "info@avdheshanandgmission.org",
      phone: "",
      address: "Haridwar, Uttarakhand, India",
    },
  },
  gallery: [
    {
      src: "/assets/agm/polyclinic-consultation.jpg",
      alt: "Doctor consulting a patient at Swami Avdheshanand Polyclinic",
      label: "Polyclinic care",
    },
    {
      src: "/assets/agm/ifs-lab.jpg",
      alt: "Students learning computers at Institute of Future Skilling",
      label: "Future skills",
    },
    {
      src: "/assets/agm/champawat-school.jpg",
      alt: "Champawat school students with mission supporters",
      label: "School education",
    },
    {
      src: "/assets/agm/mahakumbh-medical.jpg",
      alt: "Mahakumbh medical camp service",
      label: "Mahakumbh medical seva",
    },
    {
      src: "/assets/agm/mass-wedding-ceremony.jpg",
      alt: "Shagun Vivah Utsav 2026 ceremony with couples and families",
      label: "Shagun Vivah ceremony",
    },
    {
      src: "/assets/agm/mass-wedding-dignitaries.jpg",
      alt: "Swami Avdheshanand Giri ji and dignitaries at Shagun Vivah Utsav 2026",
      label: "Blessings and leadership",
    },
    {
      src: "/assets/agm/mass-wedding-zora.jpg",
      alt: "Shagun Vivah Utsav 2026 event at The Zora Convention Centre",
      label: "The Zora event",
    },
  ],
};

export function normalizeMissionConfig(config) {
  if (!config) return missionSiteFallback;

  const regions = Array.isArray(config.regions)
    ? config.regions.reduce((acc, region) => {
        if (region?.key) acc[region.key.toUpperCase()] = region;
        return acc;
      }, {})
    : config.regions || {};
  const mergedRegions = Object.entries({
    ...missionSiteFallback.regions,
    ...regions,
  }).reduce((acc, [key, region]) => {
    const normalizedKey = (region?.key || key).toUpperCase();
    const fallbackRegion = missionSiteFallback.regions[normalizedKey] || {};
    const mergedRegion = {
      ...fallbackRegion,
      ...region,
      key: normalizedKey,
    };
    // Merge donationTiers: use configured non-empty array, else fallback
    mergedRegion.donationTiers =
      Array.isArray(region?.donationTiers) && region.donationTiers.length > 0
        ? region.donationTiers
            .filter((t) => Number.isFinite(Number(t?.amount)) && Number(t?.amount) > 0)
            .map((t) => ({
              amount: Number(t.amount),
              impactLine: typeof t?.impactLine === "string" ? t.impactLine : "",
              highlighted: Boolean(t?.highlighted),
            }))
        : fallbackRegion.donationTiers || [];
    mergedRegion.blessing =
      typeof region?.blessing === "string" ? region.blessing : fallbackRegion.blessing || "";
    if (normalizedKey === "US") {
      mergedRegion.bannerImage =
        !mergedRegion.bannerImage || mergedRegion.bannerImage === LEGACY_US_BANNER_IMAGE
          ? USA_HOME_BANNER_IMAGE
          : mergedRegion.bannerImage;
      mergedRegion.bannerPosition = mergedRegion.bannerPosition || "center 72%";
    }

    acc[normalizedKey] = mergedRegion;
    return acc;
  }, {});
  const usaPresence = {
    ...missionSiteFallback.usaPresence,
    ...(config.usaPresence || {}),
    events: config.usaPresence?.events?.length
      ? config.usaPresence.events.map((event, index) => ({
          ...(missionSiteFallback.usaPresence.events[index] || {}),
          ...event,
        }))
      : missionSiteFallback.usaPresence.events,
  };
  const fallbackHomePresence = missionSiteFallback.homePresence;
  const configHomePresence = config.homePresence || {};
  const configGlobal = configHomePresence.global || {};
  const configPublicTrust = configHomePresence.publicTrust || {};
  const homePresence = {
    global: {
      ...fallbackHomePresence.global,
      ...configGlobal,
      highlights: configGlobal.highlights?.length
        ? configGlobal.highlights.map((item, index) => ({
            ...(fallbackHomePresence.global.highlights[index] || {}),
            ...item,
          }))
        : fallbackHomePresence.global.highlights,
      lineage: configGlobal.lineage?.length
        ? configGlobal.lineage.map((item, index) => ({
            ...(fallbackHomePresence.global.lineage[index] || {}),
            ...item,
          }))
        : fallbackHomePresence.global.lineage,
    },
    publicTrust: {
      ...fallbackHomePresence.publicTrust,
      ...configPublicTrust,
      moments: configPublicTrust.moments?.length
        ? configPublicTrust.moments.map((item, index) => ({
            ...(fallbackHomePresence.publicTrust.moments[index] || {}),
            ...item,
          }))
        : fallbackHomePresence.publicTrust.moments,
    },
  };

  return {
    ...missionSiteFallback,
    ...config,
    brand: { ...missionSiteFallback.brand, ...(config.brand || {}) },
    regions: mergedRegions,
    impactStats: config.impactStats?.length ? config.impactStats : missionSiteFallback.impactStats,
    programPillars: config.programPillars?.length
      ? config.programPillars
      : missionSiteFallback.programPillars,
    programDetails: config.programDetails?.length
      ? config.programDetails
      : missionSiteFallback.programDetails,
    stories: config.stories?.length ? config.stories : missionSiteFallback.stories,
    usaPresence,
    homePresence,
    swamiji: { ...missionSiteFallback.swamiji, ...(config.swamiji || {}) },
    homepageAdditions: config.homepageAdditions?.length
      ? config.homepageAdditions
      : missionSiteFallback.homepageAdditions,
    vedant: { ...missionSiteFallback.vedant, ...(config.vedant || {}) },
    transparency: { ...missionSiteFallback.transparency, ...(config.transparency || {}) },
    disclosures: { ...missionSiteFallback.disclosures, ...(config.disclosures || {}) },
    gallery: config.gallery?.length ? config.gallery : missionSiteFallback.gallery,
    visitAnnouncement:
      config.visitAnnouncement && typeof config.visitAnnouncement === 'object'
        ? { ...missionSiteFallback.visitAnnouncement, ...config.visitAnnouncement }
        : missionSiteFallback.visitAnnouncement,
  };
}

export function getRegionExperience(config, requestedRegion) {
  const normalized = normalizeMissionConfig(config);
  const key = (requestedRegion || DEFAULT_REGION_KEY).toUpperCase();
  return normalized.regions[key] || normalized.regions[DEFAULT_REGION_KEY];
}
